"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _groupBy2 = _interopRequireDefault(require("lodash/groupBy"));
var _includes2 = _interopRequireDefault(require("lodash/includes"));
var _mobx = require("mobx");
var _store = require("@tajawal/web-core-sdk-v2/lib/utils/store.utils");
var _saleFactory = require("../factories/sale-factory");
var _sale = require("../utils/sale.utils");
var _constants = require("../constants");
var _sale2 = require("./sale.store");
var _downloadOrderPdf = require("./download-order-pdf.store");
var _miscAddonApi = require("./misc-addon-api.store");
var _class; // @TODO when we update sdk on desktop & mweb update this to myaccount skd order store
// utils
// stores
/** *
 *  SaleDetailsPageStore
 */
let SaleDetailsPageStore = (_class = /*#__PURE__*/function () {
  /**
   * constructor
   * @param {Object} initialState
   * @param {Object} $env
   */
  function SaleDetailsPageStore(initialState = {}, $env) {
    (0, _classCallCheck2.default)(this, SaleDetailsPageStore);
    this.$env = $env;
    this.updateInitialState(initialState);
    this.orderPdf = new _downloadOrderPdf.DownloadOrderPdfStore(initialState.orderPdf, $env);
    this.sale = new _sale2.MyAccountSaleStore(initialState.sale, $env);
    this.pdfOrders = {};
    this.miscAddonStore = new _miscAddonApi.MiscAddonStore(initialState.miscAddonStore, $env);
  }

  /**
   * update initial state
   * @param {Object} initialState
   */
  (0, _createClass2.default)(SaleDetailsPageStore, [{
    key: "updateInitialState",
    value: function updateInitialState(initialState) {
      (0, _store.mapInitialStateToStoreState)(this, initialState);
    }
  }, {
    key: "setPdfOrders",
    value: function setPdfOrders() {
      this.sale.data.bookings.forEach(booking => {
        this.pdfOrders[booking.orderNumber] = new _downloadOrderPdf.DownloadOrderPdfStore({}, this.$env);
      });
    }

    /**
     * is Failed
     * @return {boolean}
     */
  }, {
    key: "isFailed",
    get: function () {
      return _constants.FLIGHT_BOOKING_STATUS.FAILURE === this.sale.status;
    }

    /**
     * valid products
     * @return {Array<Object>}
     */
  }, {
    key: "groupBybooking",
    get: function () {
      return (0, _sale.groupByBookings)(this.sale.data.bookings, this.$env);
    }
  }, {
    key: "orders",
    get: function () {
      return this.sale.data.orders;
    }
  }, {
    key: "bookings",
    get: function () {
      return this.sale.data.bookings && this.sale.data.bookings.map(booking => (0, _saleFactory.saleFactory)(booking, this.$env));
    }
  }]);
  return SaleDetailsPageStore;
}(), ((0, _applyDecoratedDescriptor2.default)(_class.prototype, "updateInitialState", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateInitialState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "setPdfOrders", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setPdfOrders"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isFailed", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isFailed"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "groupBybooking", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "groupBybooking"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "orders", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "orders"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "bookings", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "bookings"), _class.prototype)), _class);
exports.default = SaleDetailsPageStore;